export default "__VITE_ASSET__Chxy1DtL__"